import { Colors } from '@doordash/design-language'
import styled from 'styled-components'

export const StickyTop = styled.div`
  z-index: 2;
  position: sticky;
  top: 0;
  background-color: ${Colors.PageBackgroundPrimary};
`

export default StickyTop
